import React from 'react'
import Header from '../components/header/Header'
import MartBig from '../assets/mart-big.jpg'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'
import Description from '../components/description/description'
import { BiCheck } from 'react-icons/bi'
import TitleText from '../utils/TitleText'
import HomeButton from '../components/homebutton/HomeButton'
const Mart = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#description',title:'Description'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('Mart Integration')
  return (
    <>
        <HomeButton/>
        <Header text1="" text2="Mart Integration" text3="" img={MartBig} />
        <Description title= 'Desciption' link ='https://github.com/Anmol23oct/Mart-Integration' data={
            <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Created three Databases on AWS console: RDS, RedShift, MongoDb.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Design and Develop a web application connected to three databases.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Deploy the application on ec2 instance.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Validate the working of the webapp through querying into all three databases.</p>
            </li>

            <li>
              <BiCheck className='service__list-icon'/>
              <p>Tech Stack : React, Java , AWS, MySql, Mongo, Redshift.</p>
            </li>
    
          </ul>
        }/>
        <Contact/>
        <Footer footitems={footitems}/>
    </>
  )
}

export default Mart